export default __webpack_public_path__ + "static/media/vector.81bba4cd.svg";